export default [
  {
    path: "survey",
    meta: { label: "Survey" },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "survey-list",
        meta: { permission: "show_all_survey" },
        component: () => import("./../../views/surveysettings/headers/index.vue")
      },
      {
        path: "my-surveys",
        name: "MySurveysMain",
        meta: { label: "My Surveys" },
        component: () => import("./../../views/surveysettings/headers/widget.vue")
      },
      {
        path: "create",
        meta: { label: "Survey Create", permission: "create_survey" },
        name: "CreateSurveyMain",
        component: () => import("./../../views/surveysettings/headers/create.vue"),
      },
      {
        path: ":id/edit",
        meta: { label: "Edit Survey", permission: "edit_survey" },
        name: "EditSurveyMain",
        component: () => import("./../../views/surveysettings/headers/edit.vue"),
      },
      {
        path: ":id/take",
        meta: { label: "Take Survey", permission: "show_single_survey" },
        name: "TakeSurvey",
        component: () => import("./../../views/surveysettings/headers/take.vue")
      },
      {
        path: ":id",
        meta: { label: "Show Survey Details", permission: "show_single_survey" },
        name: "ShowSurveyMain",
        component: () => import("./../../views/surveysettings/headers/show.vue"),
      },
    ]
  }
];
